export default "__VITE_ASSET__DV$r2EIh__"